import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import Chart from "react-apexcharts";
import DataTable from "react-data-table-component";
import {
  GetInvoiceDetails,
  GetInvoiceDetailsData,
} from "../../redux/auth-reducer/auth-service";
import dayjs from "dayjs";
import { Button, Col, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";

export function Admin_report() {
  const [data, setData] = useState(false);
  const [showView, setShowView] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [itemListData, setItemListData] = useState([]);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  function sidebarfun() {
    setData(!data);
  }

  const GetRecentDataInvoice = async (data) => {
    try {
      const response = await GetInvoiceDetailsData(data); // Call your API function
      if (response?.data) {
        setItemListData(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    GetRecentDataInvoice(data); // Fetch data when currentPage changes
  }, [currentPage]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    GetRecentDataInvoice(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  // const [options, setoptions] = useState({
  //   chart: {
  //     height: 350,
  //     type: 'area'
  //   },
  //   dataLabels: {
  //     enabled: false
  //   },
  //   stroke: {
  //     curve: 'smooth'
  //   },
  //   xaxis: {

  //     categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"]
  //   },
  //   tooltip: {
  //     x: {
  //       format: 'dd/MM/yy HH:mm'
  //     },
  //   },
  // });

  // const [series, setseries] = useState([{
  //   name: 'Manager',
  //   data: [31, 40, 28, 51, 42, 109, 100],

  // }, {
  //   name: 'Player',
  //   data: [11, 32, 45, 32, 34, 52, 41],
  // }
  //   , {
  //   name: 'Total Revenue',
  //   data: [10, 30, 40, 38, 36, 20, 41],

  // }],)
  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }

  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
    },

    {
      name: "User Type",
      selector: (row) => row?.userType,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.emailId,
      sortable: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.paymentDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.paymentDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },

      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row?.amount,
      sortable: true,
    },
    {
      name: "Plan Type",
      selector: (row) => row?.planType,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => (
        <>
          {row?.status == "Active" ? (
            <button className="tablebtn active-status">Active</button>
          ) : (
            <button className="tablebtn bg-dang">Inactive</button>
          )}
        </>
      ),
      sortable: true,
    },
  ];

  const viewFn = (viewItem) => {
    setShowView(true);
  };
  const handleClosed = () => {
    setShowView(false);
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = searchText
    ? itemListData?.filter((item) => {
        return (
          item?.emailId.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.plan_type?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.User_type?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : itemListData;

  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <>
      <div className="dasboard-group">
        <TopNavbar sidebarfun={sidebarfun} />
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Report</h1>
          <div className="group_data_table">
            {/* <div className="subscription chart">
              <Chart options={options} series={series} type="area" width="1000" height="500" />

            </div> */}
            <div className="table-transaction">
              <h1 className="subscription_heading">Invoice</h1>
              <div className="search-input filter d-flex align-items-center">
                <input
                  type="text"
                  className="form-control mb-3 mt-3"
                  placeholder="Search..."
                  value={searchText}
                  onChange={handleSearch}
                />
                {searchText && (
                  <button className="btn btn-clear" onClick={clearSearch}>
                    <span>&times;</span> {/* This represents the close icon */}
                  </button>
                )}
              </div>
              {/* <DataTable

                columns={columns}
                data={filteredData}
                pagination
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                paginationTotalRows={filteredData?.length}
              /> */}

              <div>
                <DataTable
                  columns={columns}
                  data={filteredData}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows * 10}
                  paginationDefaultPage={currentPage}
                  onChangePage={setCurrentPage}
                />
                {totalRows > 1 && (
                  <Row>
                    <Col md={12} className="text-right">
                      <div className="pagination-controls">
                        <>
                          <label>Rows page: </label>{" "}
                          <select
                            id="itemsPerPage"
                            value={perPage}
                            onChange={handlePerPageChange}
                          >
                            {pageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </>

                        <Button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          <icons.ArrowLeft></icons.ArrowLeft>
                        </Button>
                        <span> of {totalRows} </span>
                        <Button
                          onClick={handleNextPage}
                          disabled={currentPage >= Math.ceil(totalRows)}
                        >
                          <icons.ArrowRight></icons.ArrowRight>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
}
